import { LanguagesEnum } from '@/api/enums';
import { ListingRequest, ListingResponse } from '@/api/types';
import { ContentSeries, Course } from '@/client/courses';
import { File } from '@/client/files';
import { Tag } from '@/client/tags';
import { TargetEntities, TargetEntitiesRequest } from '@/common/types';

export enum PlannerType {
  TRAINING_PLAN = 'training',
  ONBOARDING_PLAN = 'onboarding',
}

export enum PlannerTemplateType {
  RECOMMENDED = 'recommended',
  BLANK = 'blank',
}

export enum CourseSchedulePeriodUnit {
  DAYS = 'days',
  WEEKS = 'weeks',
  MONTHS = 'months',
}

export type EnrollOffset = {
  value: number;
  unit: CourseSchedulePeriodUnit;
};

export type PlannerCRUDCourse = {
  id: string;
  name?: string;
  thumbnailUrl?: string;
  courseThumbnail?: File;
  enrollDate?: Date;
  enrollmentHour?: number;
  enrollImmediately?: boolean;
  plannerScheduleDate?: Date | null;
  executedAt?: Date;
  periodValue?: number;
  periodUnit?: CourseSchedulePeriodUnit;
  dateKey?: string;
  isDateHeader?: boolean;
  isPastDate?: boolean;
  isLastOfDateGroup?: boolean;
  firstNonPastDate?: boolean;
  isUpcoming?: boolean;
  skipUsersEnrolledWithinGracePeriod: boolean;
  positionInPlanner?: number;
};

export type SavePlannerRequest = {
  id?: string;
  name: string;
  targets: TargetEntitiesRequest;
  courses: PlannerCRUDCourse[];
  excludes: TargetEntitiesRequest;
  accountId: string;
  type: PlannerType;
  autoEnroll?: boolean;
  isActive?: boolean;
};

export type DeletePlannerRequest = {
  accountId: string;
  planId: string;
};

export type AddCoursePlannersRequest = {
  courses: string[];
  date: Date;
};

export type PlannerCourseSchedule = {
  course: Course;
  enrollDate?: Date;
  enrollmentHour?: number;
  enrollImmediately?: boolean;
  executedAt?: Date;
  periodValue?: number;
  periodUnit?: CourseSchedulePeriodUnit;
};

export type CoursePlanner = {
  id: string;
  name: string;
  dynamicCourseSchedules: PlannerCourseSchedule[];
  excludes: TargetEntities;
  targets: TargetEntities;
  staticCourseSchedules: PlannerCourseSchedule[];
  editable?: boolean;
  type: PlannerType;
  autoEnroll?: boolean;
  isActive?: boolean;
  createdAt: Date;
  updatedAt: Date;
};

export type TargetSelectorPreviewRequest = {
  targets?: TargetEntitiesRequest;
  excludes?: TargetEntitiesRequest;
  domainVerifiedOnly?: boolean;
};

export type TargetSelectorPreviewResponse = {
  usersCount: number;
  excludedDomainUnverifiedCount: number;
};

export type ListCoursePlannerRequest = ListingRequest;
export type ListCoursePlannerResponse = ListingResponse<CoursePlanner>;

export type PlannerCoursesFiltersType = {
  tags?: Tag[];
  series?: (ContentSeries | null)[];
  courseLanguages?: LanguagesEnum[];
  search?: string;
};
